<template>
  <div :class="checked ? 'faml' : ''" class="header">
    <!-- <div class="header-nav">
      <div ref="navBg" class="nav-bg">
        <el-image :src="require('../../assets/image/resource/res_lovo.png')" fit="fill"></el-image>
      </div>
      <div v-for="(item, index) in topList" :key="item.ref" class="header-nva-item" @click="setBarWidth(item)"
        :ref="item.ref" :id="item.ref">
        {{ item.title }}
      </div>
    </div> -->
    <div :class="topActive" class="r-header">
      <div class="r-search">
        <div class="index-search-inner">
          <inputComent :ancient-show="checked" class="index-search-item" ref="parentInput" v-model.trim="searchValue">
            <el-select :popper-append-to-body="false" placeholder="请选择" slot="prepend" v-model="searchSelect">
              <el-option :key="9999" label="全部" value="全部"></el-option>

              <el-option :key="item.index" :label="item.caption" :value="item.englishName"
                         v-for="(item, index) in selectList"></el-option>
            </el-select>
            <template slot="append">
              <div class="r-search-ancient">
                <el-checkbox @change="chechkChange" v-model="checked">古壮字输入法</el-checkbox>
              </div>
            </template>
            <!-- <el-button slot="append" @click="checked = !checked" style="margin-right: 5px;" >
                              <div class="button-title"  >
                                  <div v-if="!checked">
                                      壮语输入法
                                  </div>
                                  <div v-else>
                                    古壮字检索
                                  </div>
                              </div>
                          </el-button> -->
            <el-button @click="transmit" slot="append">
              <div class="button-title">
                <el-image :lazy="true" :src="require('../../assets/image/index/jiansuo.png')" fit="fill"></el-image>
                <div>
                  检索
                </div>
              </div>
            </el-button>
          </inputComent>
          <!-- <el-input placeholder="请输入关键词" class="index-search-item" v-model="searchValue"
                      @input="inputChanges"
                      @blur="inputBlur"
                      @keydown.native.down.stop.prevent="navigateOptions('next')"
                      @keydown.native.up.stop.prevent="navigateOptions('prev')"
                      @keydown.native.left.stop.prevent="navigateOptions('left')"
                      @keydown.native.right.stop.prevent="navigateOptions('right');"
                      @keydown.native.right.remove.prevent="navigateOptions('remove');"
                      @keydown.native.enter.stop="nativeEnter"
                      ref="inputRef"
                      >
                          <el-select slot="prepend" placeholder="请选择" :popper-append-to-body="false" v-model="searchSelect">
                              <el-option :key="9999" label="全部" value="全部"></el-option>
                              <el-option :key="item.index" :label="item.caption" :value="item.englishName" v-for="(item, index) in selectList" ></el-option>
                          </el-select>
                          <el-button slot="append" @click="transmit">
                              <div class="button-title">
                                  <el-image :src="require('../../assets/image/index/jiansuo.png')" fit="fill" :lazy="true"></el-image>
                                  <div>
                                      检索
                                  </div>
                              </div>
                          </el-button>
                      </el-input> -->
          <!-- <el-collapse-transition>
                          <div class="index-search-ancient" v-show="ancient"  >
                              <div v-for="(item, index) in ancientData" :key="index" class="index-search-items" :class="is_active==index?'is-active':''" @click.stop="ancientClose(item,index)">
                                  <div>
                                      {{ item.wordCode }} {{ item.strokeCode }}
                                  </div>
                              </div>
                          </div>
                      </el-collapse-transition> -->
        </div>
        <div @click="seniors" class="r-search-button">
          高级检索
        </div>
      </div>
      <!-- <div class="r-search-ancient">
                  <el-checkbox v-model="checked" @change="chechkChange">古壮字搜索</el-checkbox>
              </div> -->
    </div>
    <div class="senior-search" v-show="senior">
      <div class="senior-main">
        <div :key="index" class="senior-box" v-for="(item, index) in orderList">
          <div :style="{ visibility: index == 0 ? 'hidden' : 'visibi' }" class="senior-or">
            <el-select class="advance-select" v-model="item.searchRelation">
              <el-option key=0 label="或者" value='0'></el-option>
              <el-option key=1 label="并且" value='1'></el-option>
            </el-select>
          </div>
          <div class="senior-augio">
            <el-select class="advance-select" v-model="item.searchName">
              <el-option :key='index' :label="items.caption" :value='items.englishName'
                         v-for="(items, index) in selectList "></el-option>
            </el-select>
          </div>
          <div class="senior-value">
            <el-input placeholder="请输入检索内容" v-model="item.searchValue">
              <template slot="append">
                <el-select v-model="item.searchType">
                  <el-option key="1" label="精确" value="1"></el-option>
                  <el-option key="0" label="模糊" value="0"></el-option>
                </el-select>
              </template>
            </el-input>
          </div>
          <div :style="{ visibility: index == 0 ? 'hidden' : 'visibi' }" class="senior-add">
            <div @click="remove(index)"><i class="el-icon-minus"></i></div>
            <div @click="addOrder" v-show="(index == orderList.length - 1)"><i class="el-icon-plus"></i></div>
          </div>
        </div>
        <div class="senior-operation">
          <el-button @click="ordeRest" class="reset">重置</el-button>
          <el-button @click="transmit(1)" class="retrieval">检索</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import inputComent from '../../components/online/InputComent.vue';
  import {listSearchParam, listWordView} from '../../api/resource'
  import {guid} from '../../utils/plugin/guid'
  import debounce from '@/utils/plugin/debounce'

  export default {
    name: 'PortalHeader',
    components: {
      inputComent
    },
    data() {
      return {
        senior: false,
        searchValue: '',
        searchSelect: '全部',
        selectList: [],
        searchList: [],
        // 高级检索 列表
        orderList: [],
        orderList1: [],
        topActive: '',
        // topList: [
        // {
        //     title:'铸牢中华民族共同体意识古籍库',
        //     ref:'zhulao'
        // },
        // {
        //     title:'中华古壮字古籍库',
        //     ref:'refs2798'
        // },
        // {
        //     title:'广西地方特色文献库',
        //     ref:'guangxidi'
        // },
        // {
        //     title:'广西经典文献当代转化库',
        //     ref:'guangxijing'
        // },
        // {
        //     title:'中华古壮字字典',
        //     ref:'guzhuangzi'
        // },
        // ],
        checked: false,
        currpage: 1,
        // 选中
        is_active: -1,
        // 古壮字 显示
        ancient: false,
        ancientData: [],
        // 输入框光标起始位置
        f_cursor: 0,
        // 输入框光标结束位置
        l_cursor: 0,
        sub: '',
      };
    },
    created() {

    },
    mounted() {
      if (this.$route.query.type) {
        this.searchSelect = this.$route.query.type
        if (this.$route.query.value) {
          this.searchValue = this.$route.query.value
        }
      }
      // if (this.$route.query.ref) {
      //   this.topActive = this.$route.query.ref
      //   setTimeout(() => {
      //     this.init({ ref: this.topActive })
      //   }, 200)
      // }
      this.getSearchParams()
    },
    methods: {
      // 检索条件
      getSearchParams() {
        listSearchParam({
          typeId: this.$store.state.typeId
        }).then(res => {
          if (res && res.data.data) {
            res = res.data.data
            //去掉不显示的高级检索值
            res.map(data => {
              // const arr = ['是否公開', '元數據模版', "元数据模板", '分類', 'ID', '主从', '审核状态', 'OAI公开状态', 'OCR识别状态', '子分類', '冊數', '图片名列表']
              const arr = ['是否公開', '元數據模版', "元数据模板", '分類', 'ID', '主从', '审核状态', 'OAI公开状态', 'OCR识别状态', '子分類', '冊數', '图片名列表'
            ,'图片路径','全文信息','分类','子分类','馆藏地址','基础价格','子库','中图分类号','书号','出版发行','原定书价','时长'

            ]
              const num = arr.findIndex(e => e == data.name)
              if (num < 0) {
                this.searchList.push(data)
              }
              return data
            })
            var hash = {}
            var arr = this.searchList.reduce(function (item, next) {
              hash[next.name] ? '' : hash[next.name] = true && item.push(next);
              return item
            }, [])
            this.selectList = JSON.parse(JSON.stringify(arr))

            arr.forEach((e, i) => {
              if (i < 3) {
                const obj = {
                  guid: guid(),
                  searchName: e.englishName,
                  searchValue: '',
                  searchRelation: '0',//检索关系 0 or ；1 and
                  searchType: '0',//检索类型 模糊类型：0，精确：1
                }
                this.orderList.push(obj)

              }
            });
            this.orderList1 = JSON.parse(JSON.stringify(this.orderList))
            // console.log( this.orderList1);
          }
        })
      },
      seniors() {
        this.senior = !this.senior
      },
      addOrder() {
        const obj = {
          guid: guid(),
          searchName: '',
          searchValue: '',
          searchRelation: '0',//检索关系 0 or ；1 and
          searchType: '0',//检索类型 模糊类型：0，精确：1
        }
        this.orderList.push(obj)
      },
      remove(index) {
        if (this.orderList.length <= 3) {
          return
        }
        this.orderList.splice(index, 1)
      },
      // 重置
      ordeRest() {
        this.orderList = JSON.parse(JSON.stringify(this.orderList1))
      },
      // 检索 高级/普通 存储 在 sessionStorage
      transmit(order) {
        /**
         * 将检索条件 存储sessionstorage
         */
        // order 高级
        if (order == 1) {
          sessionStorage.setItem('esParams', JSON.stringify(this.orderList))
          sessionStorage.setItem('senior', true)
          this.$Bus.$emit('esParams', this.orderList)
        } else {
          if (this.searchValue == '') {
            sessionStorage.removeItem('esParams')
            sessionStorage.removeItem('senior')
            this.$Bus.$emit('esParams', [])
            return
          }
          this.senior = false
          sessionStorage.setItem('senior', false)
          if (this.searchSelect == '全部') {
            let params = JSON.parse(JSON.stringify(this.selectList))
            let pa = []
            params.map((data) => {
              let obj = {
                searchName: data.englishName,
                searchValue: this.searchValue,
                searchRelation: '0',//检索关系 0 or ；1 and
                searchType: '0',//检索类型 模糊类型：0，精确：1
              }
              pa.push(obj)
              // data.searchValue = this.searchValue
              // return data
            })
            sessionStorage.setItem('esParams', JSON.stringify(pa))
            this.$Bus.$emit('esParams', pa)
          } else {
            sessionStorage.setItem('esParams', JSON.stringify([{
              guid: "ca5d6184-9ff7-d840-b207-22245fdd57b0",
              searchName: this.searchSelect,
              searchRelation: "0",
              searchType: "0",
              searchValue: this.searchValue
            }]))
            this.$Bus.$emit('esParams', [{
              guid: "ca5d6184-9ff7-d840-b207-22245fdd57b0",
              searchName: this.searchSelect,
              searchRelation: "0",
              searchType: "0",
              searchValue: this.searchValue
            }])
          }
        }
      },
      // 初始化
      init(item) {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let refs = item.ref
        var t = this.$refs[refs][0]
        var tem = t.offsetLeft / fontSize
        var widht = t.clientWidth
        var intewidht = parseInt(widht) / fontSize + 1
        var w = this.$refs.navBg
        w.setAttribute('style', ' transform: translateX(' + tem + 'rem);width:' + intewidht + 'rem;');

        const d = this.topList.find(e => e.ref == item.ref)
        if (item.ref == 'ref99999') {
          sessionStorage.removeItem('sublibrary')
          this.$Bus.$emit('sublibrary', {})
          return
        }
        sessionStorage.setItem('sublibrary', JSON.stringify({
          searchName: 'sublibrary',
          searchRelation: "1",
          searchType: "0",
          searchValue: d.title
        }))
        this.$Bus.$emit('sublibrary', JSON.stringify({
          searchName: 'sublibrary',
          searchRelation: "1",
          searchType: "0",
          searchValue: d.title
        }))
      },
      // 动态设置选中状态
      setBarWidth(item) {

        if (item.ref == this.topActive) {
          // var w = this.$refs.navBg
          // w.setAttribute('style', ' transform: translateX(-100%)');
          // this.topActive = ''
          // sessionStorage.removeItem('sublibrary')
          // this.$Bus.$emit('sublibrary', {})
          return
        }
        this.topActive = item.ref
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let refs = item.ref
        var t = this.$refs[refs][0]
        var tem = t.offsetLeft / fontSize
        var widht = t.clientWidth
        var intewidht = parseInt(widht) / fontSize + 1
        var w = this.$refs.navBg
        w.setAttribute('style', ' transform: translateX(' + tem + 'rem);width:' + intewidht + 'rem;');
        if (item.ref == 'ref99999') {
          sessionStorage.removeItem('sublibrary')
          this.$Bus.$emit('sublibrary', {})
          return
        }
        const d = this.topList.find(e => e.ref == item.ref)
        sessionStorage.setItem('sublibrary', JSON.stringify({
          searchName: 'sublibrary',
          searchRelation: "1",
          searchType: "0",
          searchValue: d.title
        }))
        this.$Bus.$emit('sublibrary', JSON.stringify({
          searchName: 'sublibrary',
          searchRelation: "1",
          searchType: "0",
          searchValue: d.title
        }))
      },
      chechkChange(e) {
        return
        this.searchValue = ''
      },
      getlistWordView(value) {
        return new Promise((provide, inject) => {
          listWordView({
            strokeCode: value,
            limit: 5,
            page: this.currpage
          }).then(res => {
            if (res.data.code == 200 && res.data.data) {
              provide(res.data.data.list)
            } else {
              this.ancient = false
              this.ancientData = []
            }
          })
        })

      },
      inputChanges: debounce(async function (e) {
        this.currpage = 1
        if (this.checked) {
          let ref = this.$refs.inputRef
          if (e == '') {
            this.ancient = false
            this.ancientData = []
            this.f_cursor = 0
            return
          }
          if (e.length < this.f_cursor && this.f_cursor != 0) {
            this.f_cursor = e.length
          }
          this.sub = this.searchValue.substring(this.f_cursor, ref.$refs.input.selectionEnd).replace(/[^\a-\z\A-\Z]/g, '')
          if (this.f_cursor == 0) {
            this.searchValue = this.searchValue.replace(/[^\a-\z\A-\Z]/g, '')
          }
          if (!this.sub) {
            this.ancient = false
            this.ancientData = []
            return
          }
          this.searchValue = this.searchValue.substring(0, this.f_cursor) + this.sub
          let data = await this.getlistWordView(this.sub)
          if (data.length != 0) {
            this.ancient = true
            this.ancientData = data
          }
        } else {
          this.f_cursor = this.searchValue.length
        }
      }, 500),
      inputBlur() {
        if (!this.checked) return
        let ref = this.$refs.inputRef
        // this.f_cursor = ref.$refs.input.selectionEnd
        this.ancient = false
        ref.$refs.input.blur()
      },
      async navigateOptions(item) {
        if (item == 'left' || item == 'right') {
          return
        }
        if (this.ancientData.length != 0) {
          if (item == 'next') {
            if (this.is_active == this.ancientData.length - 1) {
              // 翻页
              this.currpage++
              this.ancientData = await this.getlistWordView(this.sub)
            } else {
              this.is_active++
            }
          } else if (item == 'prev') {
            if (this.is_active == 0) {
              if (this.currpage == 1) return
              this.currpage--
              this.ancientData = await this.getlistWordView(this.sub)
            } else {
              this.is_active--
            }
          }
        }
        let ref = this.$refs.inputRef
        ref.$refs.input.focus()
        ref.$refs.input.setSelectionRange(this.f_cursor, ref.$refs.input.selectionEnd);
      },
      ancientClose(item, index) {
        let ref = this.$refs.inputRef
        ref.$refs.input.focus()
        ref.$refs.input.setRangeText(this.ancientData[index].wordCode, this.f_cursor, ref.$refs.input.selectionEnd)
        ref.$refs.input.setSelectionRange(ref.$refs.input.selectionEnd, ref.$refs.input.selectionEnd);
        this.searchValue = ref.$refs.input.value
        this.f_cursor = this.searchValue.length
        this.is_active = -1
        // ref.$refs.input.focus()
        this.ancient = false
        this.ancientData = []
        return false
      },
      nativeEnter() {
        if (!this.checked) return
        let ref = this.$refs.inputRef
        if (this.is_active == -1) {
          this.ancient = false
          return
        }
        ref.$refs.input.setRangeText(this.ancientData[this.is_active].wordCode, this.f_cursor, ref.$refs.input.selectionEnd)
        ref.$refs.input.focus()
        this.f_cursor = ref.$refs.input.selectionEnd
        this.text = this.ancientData[this.is_active].wordCode
        ref.$refs.input.setSelectionRange(ref.$refs.input.selectionEnd, ref.$refs.input.selectionEnd);
        this.searchValue = ref.$refs.input.value
        this.is_active = -1
        // ref.$refs.input.focus()
        this.ancient = false
        this.ancientData = []
      }
    },
    watch: {
      '$store.state.pages': {
        handler: function (news, old) {
          const pages = sessionStorage.getItem('pages')
          if(pages){
            const pagesJson = JSON.parse(pages)
            if(pagesJson.ref == 'ref99999'){
             this.topActive = 'ref99999'
            }else{
              this.topActive = 'ref'+pagesJson.code
            }
          }
        },
        deep: true,
        immediate: true
      }
    },
  };
</script>

<style lang="less" scoped>
  .header {
    .header-nav {
      width: 100%;
      height: 3.646rem;
      background: url('../../assets/image/resource/header_top.png') no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.042rem;
      font-weight: bold;
      color: #ffffff;
      // cursor: pointer;
      position: relative;

      .nav-bg {
        position: absolute;
        left: 0;
        width: 16.823rem;
        height: 2.292rem;
        z-index: 1;
        transition: -webkit-all .3s cubic-bezier(.645, .045, .355, 1);
        transition: all .3s cubic-bezier(.645, .045, .355, 1);
        transition: all .3s cubic-bezier(.645, .045, .355, 1), -webkit-all .3s cubic-bezier(.645, .045, .355, 1);
        -webkit-transition: -webkit-all .3s cubic-bezier(.645, .045, .355, 1);
        transition: all .3s cubic-bezier(.645, .045, .355, 1);;
        list-style: none;
        transform: translateX(-100%);

        .el-image {
          width: 100%;
          height: 100%;
        }
      }

      .header-nva-item {
        margin-right: 2.083rem;
        padding-left: 1rem;
        z-index: 2;
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
    }

    .r-header {
      width: 100%;
      height: 8.646rem;
      display: flex;
      // align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 8.646rem;
        background: url('../../assets/image/resource/res_bg.png') no-repeat;
        background-size: cover;
      }

      &.zhulao::before {
        filter: hue-rotate(8deg);
      }
      &.ref2796::before{
        filter: hue-rotate(180deg);
      }
      &.ref2797::before{
        filter: hue-rotate(40deg) saturate(80%);
      }
      &.ref2798::before {
        filter: hue-rotate(346deg) saturate(80%);
      }
      &.ref2799::before
      {
        filter: hue-rotate(232deg) saturate(50%);
      }
      .r-search {
        font-family: 壮文宋体;
        display: flex;
        justify-content: center;
        align-items: center;

        .index-search-inner {
          border-radius: 0.313rem;
          display: flex;
          justify-content: center;
          position: relative;

          .index-search-item {
            width: 36.458rem;
            height: 2.604rem;

            /deep/ .el-input-group__prepend {
              background-color: #ffffff;
              border: none;

              .el-select {
                background-color: #ffffff;
                color: #b1222b;
                font-size: 1rem;
                margin: -5px -20px;

                .el-input {
                  .el-input__inner {
                    font-family: "壮文宋体";
                    width: 7.292rem;
                    height: 1.54rem;
                    border-right: 0.052rem solid #b1222b;
                    text-align: center;
                    line-height: 1.54rem;
                  }

                  .el-input__suffix {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .el-input__suffix-inner {
                      .el-select__caret.el-input__icon.el-icon-arrow-up {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transform: rotateZ(0);
                      }

                      .el-select__caret.el-input__icon.el-icon-arrow-up::before {
                        content: "";
                        appearance: none; // 去除select默认的下拉图标
                        border-top: 7px solid #b1222b;
                        border-right: 7px solid transparent;
                        border-left: 7px solid transparent;
                        transition: transform .3s;
                        transform: rotateZ(0);
                      }

                      .el-select__caret.el-input__icon.el-icon-arrow-up.is-reverse::before {
                        content: "";
                        appearance: none; // 去除select默认的下拉图标
                        border-top: 7px solid #b1222b;
                        border-right: 7px solid transparent;
                        border-left: 7px solid transparent;
                        transform: rotateZ(180deg);
                      }
                    }
                  }
                }

                /deep/ .el-input.is-focus {
                  .el-input__suffix {
                    .el-input__suffix-inner {
                      transform: rotateZ(180deg)
                    }
                  }
                }

                .el-select-dropdown.el-popper {
                  .el-select-dropdown__item {
                    color: #333;
                  }

                  .el-select-dropdown__item.hover {
                    color: #b1222b;
                  }

                }
              }
            }

            /deep/ .el-input__inner {
              font-family: "壮文宋体";
              width: 29.115rem;
              height: 2.604rem;
              border: none;
            }

            /deep/ .el-input-group__append {
              background-color: #fff;

              .el-button {
                width: 6.771rem;
                height: 2.604rem;
                background-color: #b1222b;
                border-top-right-radius: 0.313rem;
                border-bottom-right-radius: 0.313rem;

                .button-title {
                  display: flex;
                  justify-content: center;

                  .el-image {
                    margin-right: 0.729rem;
                  }

                  font-size: 1.042rem;
                  color: #ffffff;
                }
              }
            }

          }

          .index-search-ancient {
            position: absolute;
            left: 7rem;
            top: 3rem;
            min-width: 146px;
            height: 200px;
            background-color: #fff;
            z-index: 999;
            overflow: hidden;
            border: 1px solid #E4E7ED;
            border-radius: 4px;
            box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
            box-sizing: border-box;
            margin: 5px 0;
            padding: 10px 0;

            .index-search-items {
              font-size: 18px;
              padding: 0 20px;
              position: relative;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #606266;
              height: 34px;
              line-height: 34px;
              box-sizing: border-box;
              cursor: pointer;

              &:hover,
              &.is-active {
                color: #b1222b;
                background-color: #F5F7FA;
              }
            }
          }
        }

        .r-search-button {
          width: 7.292rem;
          height: 2.604rem;
          background-color: #b1222b;
          border-radius: 0.313rem;
          border: solid 0.052rem #cccccc;
          font-size: 1.042rem;
          color: #ffffff;
          text-align: center;
          line-height: 2.604rem;
          margin-left: 0.521rem;
          z-index: 1;
          cursor: pointer;
        }
      }

      .r-search-ancient {
        display: inline-block;
        margin-right: 2rem;

        /deep/ .el-checkbox {
          &:last-of-type {
            font-size: 14px;
            display: flex;
            align-items: center;

            .el-checkbox__input {
              &.is-checked {
                .el-checkbox__inner {
                  background-color: red;
                  border-color: red;
                }
              }

              .el-checkbox__inner {
                width: 16px;
                height: 16px;

                &::after {
                  height: 10px;
                  left: 6px;
                  top: 1px;
                }

              }
            }

            &.is-checked {
              .el-checkbox__label {
                color: red;
              }
            }

            .el-checkbox__label {
              font-size: 1rem;
            }
          }
        }
      }

    }

    .senior-search {
      width: 62.5rem;
      min-height: 13.438rem;
      background-color: rgba(255, 255, 255, .5);
      margin: 0 auto;
      padding: 0.521rem;
      margin-top: 0.833rem;

      .senior-main {
        width: 61.458rem;
        min-height: 13.438rem;
        background-color: #ffffff;
        padding-top: 1.042rem;

        .senior-box {
          margin-left: 4.513rem;
          margin-right: 3.479rem;
          display: flex;
          margin-bottom: 0.833rem;

          .senior-or {
            width: 5.208rem;
            height: 2.083rem;
            margin-right: 0.521rem;

            /deep/ .el-select {
              .el-input {
                font-size: 0.833rem;

                .el-input__inner {
                  color: #333333;
                  width: 5.208rem;
                  height: 2.083rem;
                }
              }
            }
          }

          .senior-augio {
            margin-right: 0.26rem;

            /deep/ .el-select {
              .el-input {
                font-size: 0.833rem;

                .el-input__inner {
                  color: #333333;
                  width: 8.333rem;
                  height: 2.083rem;
                }
              }
            }
          }

          .senior-value {
            width: 34.375rem;
            height: 2.083rem;

            /deep/ .el-input {
              color: #333333;

              .el-input__inner {
                border-right: none;
                font-size: 0.833rem;
                height: 2.083rem;
              }

              .el-input-group__append {
                background-color: #fff;

                .el-select {
                  .el-input {
                    .el-input__inner {
                      height: 1.6rem;
                      border-left: 1px solid #DCDFE6;
                      width: 5.729rem;
                      font-size: 0.833rem;
                    }
                  }
                }
              }
            }
          }

          .senior-add {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #cccccc;
            font-size: 0.9rem;

            div {
              cursor: pointer;
              height: 2.083rem;
              width: 2.083rem;
              line-height: 2.083rem;
              text-align: center;
            }
          }
        }

        .senior-operation {
          display: flex;
          justify-content: center;

          .el-button.reset {
            width: 7.813rem;
            height: 2.396rem;
            background-color: #ffffff;
            border-radius: 0.208rem;
            border: solid 0.052rem #bbbbbb;
            font-size: 0.833rem;
            color: #333333;
          }

          .el-button.retrieval {
            width: 7.813rem;
            height: 2.396rem;
            background-color: #b1222b;
            border-radius: 0.208rem;
            font-size: 0.833rem;
            color: #ffffff;
          }
        }
      }
    }
  }</style>
